module.exports = __webpack_public_path__ + "img/icon-vot-cashpayment.1e0e9cb9.png";